/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcutils.vcshare')
    .component('shareform', {
      restrict: 'E',
      bindings: {
        share: '<',
        parentsave: '&',
        oncancel: '&'
      },
      templateUrl: 'vcutils/share/shareform-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log',
        function ($log) {
          let vm = this;
          vm.save = save;
          vm.cancel = cancel;
          // vm.zipsave = zipsave;
          
          vm.$onInit = function () {
            vm.lastshare = angular.copy(vm.share);
          };
          
          function save() {
            if (!angular.equals(vm.share, vm.lastshare)) {
              vm.lastshare = angular.copy(vm.share);
              vm.parentsave({share: vm.share});
            }
          }
          
          function cancel() {
            vm.share = angular.copy(vm.lastshare);
            vm.oncancel();
          }
        }] // controller
    }); // component

// klammerfriedhof
}());
